import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.css'
import {Provider} from 'react-redux'
import App from './App'
import { store } from './store'
import { BrowserRouter as Router } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
)